import './App.css';
import {Header, Currency} from "./components";


function App() {

    return (
        <div className="App">
            <Header/>
            <Currency/>
        </div>
    );
}

export default App;
